export const CALCULATE_WORKING_HOURS_LOAD = 'CALCULATE_WORKING_HOURS_LOAD'
export const CALCULATE_WORKING_HOURS_LOAD_FULFILLED = 'CALCULATE_WORKING_HOURS_LOAD_FULFILLED'
export const CALCULATE_WORKING_HOURS_LOAD_REJECTED = 'CALCULATE_WORKING_HOURS_LOAD_REJECTED'

export const CALCULATE_HALFDAY_WORKING_HOURS_LOAD = 'CALCULATE_HALFDAY_WORKING_HOURS_LOAD'
export const CALCULATE_HALFDAY_WORKING_HOURS_LOAD_FULFILLED =
  'CALCULATE_HALFDAY_WORKING_HOURS_LOAD_FULFILLED'
export const CALCULATE_HALFDAY_WORKING_HOURS_LOAD_REJECTED =
  'CALCULATE_HALFDAY_WORKING_HOURS_LOAD_REJECTED'
